module.exports = __webpack_public_path__ + "img/hiw_icon_Upload_PartnerBulk.d68dac0c.png";